module.exports = __webpack_public_path__ + "img/home-graphic-en-BE.53d1e0bf.png";